import {isnull, localGet, localSave} from "../utils/tools";
import {get, postQ, postQB} from "../apiconfig";
import global from "../config/global";

export default {
  callAnchor(targetAcc, successCallback = null, failCallBack = null, vueObj, showLoading = false, hideLoading = false) {
    return postQ('api/RoomV2/UserCall', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  stopCallAnchor(targetAcc, successCallback = null, failCallBack = null, vueObj, showLoading = false, hideLoading = false) {
    return postQ('api/RoomV2/UserStopCall', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  addCommentUpTags(targetAcc,tags, successCallback = null, failCallBack = null, vueObj, showLoading = false, hideLoading = false) {
    return postQB('api/Room/AddCommentUpTag', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc],tags, function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  addCommentDownTags(targetAcc,tags, successCallback = null, failCallBack = null, vueObj, showLoading = false, hideLoading = false) {
    return postQB('api/Room/AddCommentDownTag', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc],tags, function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  commentAnchor(targetAcc, roomId,commentType,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Room/UserComment', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc,'roomId='+roomId,'commentType='+commentType], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  userSendGift(targetAcc, roomId,giftId,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Room/UserSendGift', ['session=' + localGet(global.key.session), 'anchorId=' + targetAcc,'roomId='+roomId,'giftId='+giftId], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  hangupCall(successCallback=null,failCallback=null,vueObj,showLoading=true,hideLoading=true){
    return postQ('api/Room/Hangup', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  addChatConsume(targetAccountId,successCallback=null,failCallback=null,vueObj){
    return postQ('api/RoomV2/AddChatConsumeV2', ['session=' + localGet(global.key.session),'targetAccountId='+targetAccountId], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  }
}



// WEBPACK FOOTER //
// ./src/api/room-api.js